import { gsap } from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

const scrollTo = {
	init() {

        let scrollLinks = document.querySelectorAll('.js-scroll-to');
        let headerHeight = "80";

        if (scrollLinks.length > 0){
            scrollLinks.forEach(function(link) {	
                let target = link.dataset.target;
                link.addEventListener('click', function() { 
                    gsap.to(window, 0.8, {scrollTo:{y: target, offsetY: headerHeight}, ease: 'power3.inOut'});    
                }, false);
            });
        }

	},
};

const moveOnScrollY = {
	init() {
1
		const move = (target) => {
            
			let obj = target.querySelectorAll('.js-move-on-scrolly-obj'),
				pos = 'top bottom',
				amount = '10%';

			if (target.dataset.scrollyposition) {
				pos = target.dataset.scrollyposition;
			} 
			if (target.dataset.scrollyamount) {
				amount = target.dataset.scrollyamount;
			}

			gsap.to(obj, {
				scrollTrigger: {
					trigger: target,
					toggleActions: 'play pause reverse pause',
					start: pos,
					// markers: true,
					scrub: 1,
				},
				y: amount,
				ease: 'power2.out',
			})
		}

        let scrollElems = document.querySelectorAll('.js-move-on-scrolly');

		if (scrollElems.length > 0){
			scrollElems.forEach((elem) => {	
				move(elem);
			});
		}

	},
};

const moveOnScrollX = {
	init() {

		const move = (target) => {
            
			let obj = target.querySelector('.js-move-on-scrollx-obj'),
				pos = 'top bottom',
				amount = '10%';
			let mm = gsap.matchMedia();
			
			const canHover = window.matchMedia('(hover: hover)').matches;
			if (canHover === true) { 
				mm.add("(min-width: 800px)", () => {

					if (target.dataset.scrollxposition) {
						pos = target.dataset.scrollxposition;
					} 
					if (target.dataset.scrollxamount) {
						amount = target.dataset.scrollxamount;
					}

					gsap.to(obj, {
						scrollTrigger: {
							trigger: target,
							toggleActions: 'play pause reverse pause',
							start: pos,
							//markers: true,
							scrub: 1,
						},
						x: amount,
						ease: 'power2.out',
					})
				
				});
			}

		}

        let scrollElems = document.querySelectorAll('.js-move-on-scrollx');

		if (scrollElems.length > 0){
			scrollElems.forEach((elem) => {	
				move(elem);
			});
		}

	},
};

export {scrollTo, moveOnScrollY, moveOnScrollX};